/**
 * @surfline/quiver-react v9.0.1 2020-04-10
 */

import _extends$1 from '@babel/runtime/helpers/esm/extends';
import React$1 from 'react';
import 'prop-types';
import createAccessibleOnClick$1, { BTN } from '../utils/createAccessibleOnClick.js';
import ContentCardPaywall$1 from '../ContentCardPaywall/ContentCardPaywall.js';
import ShareArticle$1 from '../ShareArticle/ShareArticle.js';

const ForecastArticleBody = ({
  id,
  title,
  body,
  showMore,
  url,
  showShare,
  onClickShareArticle,
  showPaywall,
  onClickReadMore,
  funnelUrl,
  onClickPaywall,
  showAll,
  toggleShowMore
}) => /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-forecast-article-card__body-wrapper"
}, /*#__PURE__*/React$1.createElement("h2", {
  dangerouslySetInnerHTML: {
    __html: title
  }
}), /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-forecast-article-card__body-container"
}, /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-forecast-article-card__body",
  dangerouslySetInnerHTML: {
    __html: body
  },
  id: id
}), (showAll || showMore) && url && showShare ? /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-forecast-article-card__body__share"
}, /*#__PURE__*/React$1.createElement("span", {
  className: "quiver-forecast-article-card__body__share__title"
}, "Share this post"), /*#__PURE__*/React$1.createElement(ShareArticle$1, {
  url: url,
  onClickLink: onClickShareArticle
})) : null, !showAll && !showPaywall ? /*#__PURE__*/React$1.createElement("a", _extends$1({
  role: "button",
  className: "quiver-forecast-article-card__read-more-less"
}, createAccessibleOnClick$1(toggleShowMore, BTN)), /*#__PURE__*/React$1.createElement("span", createAccessibleOnClick$1(onClickReadMore, BTN), showMore ? 'Read Less' : 'Read More')) : null, showPaywall && /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-forecast-article-card__content-fade"
})), showPaywall && /*#__PURE__*/React$1.createElement(ContentCardPaywall$1, {
  funnelUrl: funnelUrl,
  onClick: onClickPaywall
}));

ForecastArticleBody.defaultProps = {
  id: null,
  body: '',
  showPaywall: false,
  showMore: false,
  funnelUrl: '',
  onClickPaywall: null,
  onClickReadMore: null,
  onClickShareArticle: null,
  url: '',
  showShare: true,
  showAll: true,
  toggleShowMore: null
};

export default ForecastArticleBody;
//# sourceMappingURL=ForecastArticleBody.js.map
